import Vue from "vue";
import UIkit from "uikit";
import "../node_modules/uikit/dist/js/uikit.js";
import Icons from "../node_modules/uikit/dist/js/uikit-icons.min.js";
import "../node_modules/uikit/dist/js/uikit-icons.js";
import "../node_modules/uikit/src/less/uikit.less";
import "../node_modules/simplebar-vue/dist/simplebar.min.css";
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask';
import vmodal from 'vue-js-modal';
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import 'babel-polyfill';
import JsonCSV from 'vue-json-csv'

Vue.component('downloadCsv', JsonCSV);
Vue.use(vmodal, { dynamic: true, injectModalsContainer: true });
Vue.use(VueMask);
Vue.use(Vuelidate);
UIkit.use(Icons);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
